import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import "./userListing.css";
import {
  Form,
  Table,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  IconUserShare,
  IconUserOff,
  IconTrash,
  IconCircleCheckFilled,
  IconUserCheck,
} from "@tabler/icons-react";
import DynamicPagination from "../../components/DynamicPagination ";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";
import { getAbbreviation } from "../../utils/_helpers";
import { toast } from "react-toastify";
import DeactivateUserModal from "./DeactivateUserModal";
import AssignRoleModal from "./AssignRoleModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import userp from "../../assets/user-Avtar.svg";
import ActivateUser from "./ActivateUser";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/_helpers";
import useIdleLogout from "../../hooks/useIdleLogout";

const UserListing = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchEmail, setSearchEmail] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [isDeactivate, setIsDeactivate] = useState({ show: false, user: null });
  const [isActivate, setisActivate] = useState({ show: false, user: null });
  const [isAssignRole, setIsAssignRole] = useState({ show: false, user: null });
  const [isDeleteUser, setIsDeleteUser] = useState({ show: false, user: null });

  const user = useSelector((state) => state.auth.user);
  // check perminssion

  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);

  const userAssignRole = user?.permissions?.manage_role || [];
  const canDeleteUser = hasPermission(userAssignRole, "delete");
  const canAssignRole = hasPermission(userAssignRole, "write");
  // check perminssion

  const { postData: fetchUsers, data } = usePostRequest(
    API_ENDPOINTS.GET_USERS
  );
  const { postData: fetchRoles, data: roles } = usePostRequest(
    API_ENDPOINTS.GET_ROLES
  );
  const { postData: deleteUser } = usePostRequest(API_ENDPOINTS.DELETE_USER);

  const { debounceSearch } = useDebounce(searchEmail);

  const handleSearchEmail = (e) => {
    setSearchEmail(e.target.value);
  };

  const handleRoleFilter = (e) => {
    setRoleFilter(e.target.value);
  };

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
  };

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setLimit(selectedLimit);
  };

  const onSuccessfulDelete = (response) => {
    toast.success(response.message || "User deleted successfully");
    fetchUsers();
  };

  const onErrorDelete = (error) => {
    console.log("error");
    toast.error(error?.message || "Failed to delete user");
  };

  const handleDeleteUser = () => {
    const { user } = isDeleteUser;
    deleteUser({ username: user.username }, onSuccessfulDelete, onErrorDelete);
  };

  const handleDeleteUserClick = (user) => {
    setIsDeleteUser({ show: true, user });
  };

  const handleDeactivateClick = (user) => {
    setIsDeactivate({ show: true, user });
  };

  const handleActivateClick = (user) => {
    setisActivate({ show: true, user });
  };

  const handleAssignRoleClick = (user) => {
    setIsAssignRole({ show: true, user });
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  useIdleLogout();

  useEffect(() => {
    fetchUsers({
      page,
      limit,
      email: searchEmail?.length > 0 ? searchEmail : undefined,
      role_name: roleFilter == "all" ? undefined : roleFilter,
      status: statusFilter === "all" ? undefined : statusFilter,
    });
  }, [page, limit, debounceSearch, roleFilter, statusFilter]);

  return (
    <>
      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title">User Management</h2>
          </div>
        </div>
      </div>

      <Card className="mb-4">
        <Card.Body>
          <Row>
            <Col md={4} className="mb-3">
              <Form.Label className="form-label">Search by Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter Email"
                required
                name="name"
                autoComplete="off"
                value={searchEmail}
                onChange={handleSearchEmail}
              />
            </Col>
            <Col md={4} xs={6} className="mb-3">
              <Form.Label className="form-label">
                Select User Department
              </Form.Label>
              <Form.Select
                className="form-control"
                value={roleFilter}
                onChange={handleRoleFilter}
              >
                <option value={"all"}>All Departments</option>
                {roles?.data?.map((role) => (
                  <option key={role?.id} value={role?.name}>
                    {role?.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={4} xs={6} className="mb-3">
              <Form.Label className="form-label">Select Status</Form.Label>
              <Form.Select
                className="form-control"
                value={statusFilter}
                onChange={handleStatusFilter}
              >
                <option value={"all"}>All</option>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </Form.Select>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {data?.data?.length > 0 ? (
        <>
          <Row>
            {data?.data?.map((user, index) => {
              return (
                <Col key={index} lg={4} md={6} sm={12} className="mb-3">
                  <Card className="user_card_box">
                    <div className="card_head">
                      <div className="inner_card_head">
                        <Card.Img className="" src={userp} />
                        <div>
                          <Card.Title>{`${user?.first_name} ${user?.last_name}`}</Card.Title>
                          <p className="label_card text-capitalize">
                            Username: {user?.username}
                          </p>
                          <p className="label_card text-capitalize">
                            Dept Head:{" "}
                            {user?.headed_departments &&
                            user?.headed_departments.length > 0
                              ? user.headed_departments
                                  .map((dep) => dep.name)
                                  .join(", ")
                              : "N/A"}
                          </p>

                          {user?.is_active ? null : (
                            <p className="label_card text-capitalize mb-0 text-yellow">
                              Reason: {user?.remark}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="user_status_info">
                        <span
                          className={`${
                            user?.is_active
                              ? "badge_card bg-green-lt"
                              : "badge_card bg-yellow-lt"
                          }`}
                        >
                          {user?.is_active ? (
                            <>
                              <IconCircleCheckFilled /> Active
                            </>
                          ) : (
                            <>
                              <IconUserOff /> Deactive
                            </>
                          )}
                        </span>
                      </div>
                    </div>
                    <Card.Body>
                      <div className="rfq_card_row">
                        <div className="rfq_item_card">
                          <span className="value_card ">Account Created</span>
                          <p className="label_card mb-0">
                            {" "}
                            {moment(user?.createdAt).format("YYYY-MM-DD") ||
                              "NA"}
                          </p>
                        </div>
                        <div className="rfq_item_card">
                          <span className="value_card ">User Department</span>
                          <p className="label_card text-capitalize gap-1 mb-0">
                            {user?.Roles?.map(
                              (role, idx) =>
                                `${role?.name}${
                                  idx === user?.Roles.length - 1 ? "" : ", "
                                }`
                            )}
                          </p>
                          {/* {user?.Roles?.map((role) => (
                              <span className="value_card  gap-1">
                                {role?.name}
                                </span>
                            ))} */}
                        </div>
                      </div>
                      <div className="rfq_card_row mb-0">
                        <div className="rfq_item_card">
                          <span className="value_card ">User Email</span>
                          <p className="label_card  mb-0"> {user?.email}</p>
                        </div>
                        <div className="item_card">
                          <div className="value_card d-flex gap-1">
                            {canAssignRole && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip>Assign Roles</Tooltip>}
                              >
                                <span
                                  className="avatar bg-lime-lt rounded-circle badge-outline"
                                  onClick={() => handleAssignRoleClick(user)}
                                >
                                  <IconUserShare stroke={1.25} />
                                </span>
                              </OverlayTrigger>
                            )}

                            {user?.is_active
                              ? canAssignRole && (
                                  <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Tooltip>Deactivate User</Tooltip>}
                                  >
                                    <span
                                      className="avatar bg-yellow-lt rounded-circle badge-outline"
                                      onClick={() =>
                                        handleDeactivateClick(
                                          user,
                                          "deactivate"
                                        )
                                      }
                                    >
                                      <IconUserOff stroke={1.25} />
                                    </span>
                                  </OverlayTrigger>
                                )
                              : canAssignRole && (
                                  <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Tooltip>Activate User</Tooltip>}
                                  >
                                    <span
                                      className="avatar bg-yellow-lt rounded-circle badge-outline"
                                      onClick={() => handleActivateClick(user)}
                                    >
                                      <IconUserCheck stroke={1.25} />
                                    </span>
                                  </OverlayTrigger>
                                )}

                            {canDeleteUser && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip>Delete User</Tooltip>}
                              >
                                <span
                                  className="avatar bg-pink-lt rounded-circle badge-outline"
                                  onClick={() => handleDeleteUserClick(user)}
                                >
                                  <IconTrash stroke={1.25} />
                                </span>
                              </OverlayTrigger>
                            )}
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </>
      ) : (
        <div>No Data Found</div>
      )}

      {data?.data?.length > 0 && (
        <DynamicPagination
          totalPages={data?.pagination?.totalPages}
          currentPage={page}
          onPageChange={handlePageChange}
          limitPerPage={limit}
          onLimitChange={handleLimitChange}
        />
      )}

      {isDeactivate?.show && (
        <DeactivateUserModal
          isOpen={isDeactivate}
          onClose={() => setIsDeactivate({ show: false, user: null })}
          fetchUsers={fetchUsers}
        />
      )}
      {/* active user */}
      {isActivate?.show && (
        <ActivateUser
          isOpen={isActivate}
          onClose={() => setisActivate({ show: false, user: null })}
          fetchUsers={fetchUsers}
        />
      )}

      {isAssignRole?.show && (
        <AssignRoleModal
          isOpen={isAssignRole}
          onClose={() => setIsAssignRole({ show: false, user: null })}
          fetchUsers={fetchUsers}
        />
      )}
      {isDeleteUser?.show && (
        <ConfirmationModal
          show={true}
          onConfirm={handleDeleteUser}
          onHide={() => setIsDeleteUser({ show: false, user: null })}
          message={
            "Are you sure want to delete this user? <br /> This action cannot be undone."
          }
          type="danger"
        />
      )}
    </>
  );
};

export default UserListing;
